export const MARKET = {
  CODE: CODE_MARKET
};


// WEBPACK FOOTER //
// ./src/js/utils/market.constants.js